<template>
  <div>
    <div v-if="listDateOrder.length > 0 && listDateTask.length > 0">
      <v-tabs v-model="tab" background-color="white">
        <v-tab> Designer </v-tab>
        <v-tab> Sales </v-tab>
        <v-tab> Account Health </v-tab>
        <v-spacer></v-spacer>
        <v-btn
          color="success"
          @click="loadData"
          style="margin-right: 20px; margin-top: 3px"
          >Refresh</v-btn
        >
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card>
            <template>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="6">
                  <TaskNotCompleteStack
                    :dataNotComplete="listTaskNotComplete"
                    :listDate="listDateNotComplete"
                  />
                </v-col>

                <v-col cols="12" sm="12" md="12" lg="6">
                  <TaskNotCompletePie
                    :dataNotComplete="listTaskNotComplete"
                    :listDate="listDateNotComplete"
                  />
                </v-col>

                <v-col cols="12" sm="">
                  <Task
                    style="height: 50vh"
                    :dataTask="dataTask"
                    :listDate="listDateTask"
                    :listDesigner="listDesigner"
                  />
                </v-col>
                <v-col cols="12" sm="2">
                  <TaskTotal
                    :dataTask="dataTask"
                    :listDate="listDateTask"
                    :listDesigner="listDesigner"
                  />
                </v-col>
              </v-row>
            </template>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card>
            <template>
              <v-row>
                <v-col cols="12" sm="12">
                  <Site
                    :dataOrder="dataOrder"
                    :listDate="listDateOrder"
                    :listSite="listSite"
                  />
                </v-col>
                <v-col cols="12" sm="12">
                  <Listing :dataListing="listListingPerformance" />
                </v-col>
              </v-row>
            </template>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card>
            <template>
              <v-row>
                <v-col cols="12" sm="12">
                  <AccHealth :listAccHealth="listAccHealth" />
                </v-col>
              </v-row>
            </template>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <div v-else>
      <img v-bind:src="require('../../../assets/loading/loading.gif')" />
    </div>
  </div>
</template>

<script>
import Site from "./c-chart-overall-site";
import Task from "./c-chat-overall-task";
import TaskTotal from "./c-chart-overall-total-user-task";
import TaskNotCompleteStack from "./c-chart-overall-not-complete-stack";
import TaskNotCompletePie from "./c-chart-overall-not-complete-pie";
import Listing from "./c-chart-overall-listing-amazon";
import AccHealth from "./c-chart-overall-amz-acc-health.vue";
import axios from "axios";
//import Vue from "vue";
//import HTTP from "../http-common"
import Amplify from "aws-amplify";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  components: {
    Site,
    Task,
    TaskTotal,
    TaskNotCompleteStack,
    TaskNotCompletePie,
    Listing,
    AccHealth,
  },

  data: () => ({
    tab: null,
    dataOrder: {},
    dataTask: {},
    listDateOrder: [],
    listDateTask: [],
    listDateNotComplete: [],
    listSite: [],
    listDesigner: [],
    listTaskNotComplete: [],
    listListingPerformance: [],
    listAccHealth: [],
  }),

  methods: {
    async loadData() {
      this.dataOrder = {};
      this.dataTask = {};
      this.listDateOrder = [];
      this.listDateTask = [];
      this.listSite = [];
      this.listDesigner = [];
      this.listTaskNotComplete = [];
      this.listDateNotComplete = [];

      var currentSession = await this.$root.$refs.App.currentSession(
        "chart-overall"
      );
      if (currentSession.accessToken) {
        axios
          .get(window.domain + "reports/overall", {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            // If request is good...
            //console.log("response: ",response)
            this.dataOrder = response.data.data.Orders;
            this.listSite = response.data.data.Sites;
            this.listDesigner = response.data.data.Designers;
            this.dataTask = response.data.data.Tasks;
            this.listTaskNotComplete = response.data.data.NotCompletedTasks;
            this.listListingPerformance =
              response.data.data.AmazonListingPerformance;
            this.listAccHealth = response.data.data.AmazonAccountHealth;
            for (const i in this.dataOrder) {
              this.listDateOrder.push(i);
            }

            for (const i in this.dataTask) {
              this.listDateTask.push(i);
            }

            for (const i in this.listTaskNotComplete) {
              this.listDateNotComplete.push(i);
            }
          })
          .catch((error) => {
            console.log("error ", error);
          });
      } else {
        console.log("currentSession chart-overall-undefined: ", currentSession);
      }
    },
  },

  mounted() {
    this.loadData();
  },
};
</script>

<style lang="scss" scoped>
</style>